import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useBots } from "@/hooks/useApi";
import LoadingSpinner from "@/components/LoadingSpinner";
import { useTranslation } from "../../hooks/useTranslation";

/**
 * Layout wrapper for bot-specific pages
 * Provides bot context and handles loading states
 */
export function BotLayout({ children, title }) {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data: bots, isLoading, error } = useBots();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-center">
          <h2 className="text-lg font-semibold text-red-600 mb-2">
            {t("common.error", "Error")}
          </h2>
          <p className="text-gray-600">
            {t("errors.botLoadFailed", "Failed to load bot information")}
          </p>
        </div>
      </div>
    );
  }

  const bot = Array.isArray(bots) ? bots.find((b) => b._id === id) : null;

  if (!bot) {
    return <Navigate to="/bots" replace />;
  }

  return (
    <div className="space-y-6 min-w-0">
      {/* Bot Header - Optional additional info 
      {title && (
        <div className="bg-muted/50 rounded-lg p-4">
          <h2 className="text-lg font-semibold mb-1">{title}</h2>
          <p className="text-muted-foreground text-sm">
            Managing {title.toLowerCase()} for <strong>{bot.name}</strong>
          </p>
        </div>
      )}
        */}

      {/* Page Content */}
      <div className="p-4 pt-2 min-w-0">
        {React.cloneElement(children, { bot })}
      </div>
    </div>
  );
}

export default BotLayout;
